<template>
  <AppLink :to="icon.url" class="app-social" :aria-label="ariaLabel" :ga-event="gaEvent">
    <Component :is="iconComponentName" />
  </AppLink>
</template>

<script>
import ExternalLinkClickedGaEvent from '@/helpers/ga/events/ExternalLinkClickedGaEvent';
import AppLink from '@/components/AppLink.vue';

export default {
  name: 'AppSocial',
  components: {
    AppLink,
    AppSocialInstagram: () => import('@/components/AppSocialInstagram.vue'),
    AppSocialLinkedin: () => import('@/components/AppSocialLinkedin.vue'),
    AppSocialSubstack: () => import('@/components/AppSocialSubstack.vue'),
  },
  props: {
    icon: {
      type: Object,
      required: true,
    },
  },
  computed: {
    alt() {
      return `${this.icon.name} logo`;
    },
    ariaLabel() {
      return `Visit our ${this.icon.name} page`;
    },
    iconComponentName() {
      return `AppSocial${this.icon.platform[0].toUpperCase() + this.icon.platform.substr(1)}`;
    },
    gaEvent() {
      return new ExternalLinkClickedGaEvent()
        .addPageSection('footer_navigation')
        .addLinkUrl(this.icon.url)
        .addLinkType(this.icon.platform);
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.app-social {
  display: block;
  width: 100%;
  height: 100%;
  color: vars.$c-dark-gray;
}
</style>
